import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';
import { TestScheduler } from 'rxjs-compat';
import { SharedService } from '../../../layouts/shared-service';
import { AnalysisDetails } from '../../../model/analysis-details.model';
import { DropDownService } from '../../../service/drop-down.service';
import { StorageService } from '../../../service/storage.service';

@Component({
  selector: 'app-ap-report',
  templateUrl: './ap-report.component.html',
  styleUrls: ['./ap-report.component.scss']
})
export class APReportComponent implements OnInit {


  @Input() analysistype: string;
  @Input() editvalues:any;
  @Output() formvalue = new EventEmitter<any>();
  pageTitle = 'Analyze Report/Data';
  analysisFormGroup_AP : FormGroup;
  maxDate;
  lts80_dialog: FormControl = new FormControl();
  analysisDetails: AnalysisDetails;
  subtype: AnalysisDetails;
  tableNamesList: any[];
  tableNames: any[];
  showTable: boolean = false;
  countTable: boolean = false;
  selectedTablesList = [];
  post: any;

  pattern1 = '^([a-zA-Z0-9\\s]+[-&/])*([a-zA-Z0-9\\s])+?$';
  stdConc_pattern = '^[-]?[0-9]+([,.][0-9]+)?$';
  stdConc_validator: boolean;

  openSecondMatStep: string;

  constructor(
    private formBuilder: FormBuilder,
    private _sharedService: SharedService,
    private dropDownService: DropDownService,
    private storageService: StorageService,
    private ref: ChangeDetectorRef
  ) {
    this._sharedService.emitChange(this.pageTitle);
   }

  ngOnInit(): void {
    this.createForm();
  }


  createForm() {
    this.analysisFormGroup_AP = this.formBuilder.group({
      analysisType: ['AP'],
      analysisSubtype: ['logistic'],
      analyteNames: this.formBuilder.array([this.formBuilder.control([], Validators.pattern(this.pattern1))]),
      projectCode: ['', [Validators.pattern(this.pattern1), Validators.maxLength(50), Validators.required]]
    })

    this.ref.detectChanges();


  }

  get formControls() { return this.analysisFormGroup_AP.controls; }


  get analyteNames() {
      return this.analysisFormGroup_AP.get('analyteNames') as FormArray;

  }



  onSubmit(post) {

      // tslint:disable-next-line: max-line-length
      this.analysisDetails = Object.assign({}, this.analysisFormGroup_AP.value);



      // this.analysisDetails.selectedTablesList = this.selectedTablesList.map(res =>
      //   res = res.description);

      this.openSecondMatStep = this.analysisDetails.analysisType;

      this.analysisDetails.userId = this.storageService.get('username');

      this.analysisDetails.analysisId = (new Date).getTime().toString();

      this.analysisDetails.analyteName = this.analyteNames.value

       console.log(this.analyteNames);
       console.log(this.analysisDetails.analyteName);

      this.post = post;
      this.formvalue.emit(this.analysisDetails);

    }


    resetAnalysis() {

      // this.getData();
    }

    getDropDownValues(key) {
      return this.dropDownService.dropDownsMap.get(key);
    }


}
